import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { authForgotPassword, formatApiErrorDetail } from "../lib/api";
import { Reveal } from "../components/Motion";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Reset Password — Motion & Meaning";
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await authForgotPassword({ email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative min-h-screen flex items-center" data-testid="forgot-password-page">
      <div className="mm-vignette" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 w-full pt-32 pb-24">
        <div className="max-w-md">
          <Reveal>
            <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">ACCOUNT RECOVERY</p>
            {sent ? (
              <div data-testid="forgot-success">
                <h1 className="font-serif text-5xl md:text-6xl font-light leading-[0.95] text-white">
                  Check your<br />inbox.
                </h1>
                <p className="text-white/60 leading-relaxed mt-8">
                  If an account exists for <span className="text-white/90">{email}</span>, a reset
                  link is on its way. It expires in 30 minutes and can be used once.
                </p>
                <Link to="/login" data-testid="forgot-back-login" className="inline-block mt-10 font-mono text-[11px] tracking-[0.25em] text-white/50 hover:text-gold transition-colors">
                  ← BACK TO SIGN IN
                </Link>
              </div>
            ) : (
              <>
                <h1 className="font-serif text-5xl md:text-6xl font-light leading-[0.95] text-white">
                  Forgot your<br />password?
                </h1>
                <p className="text-white/60 leading-relaxed mt-8">
                  Enter the email on your account and we'll send you a secure link to reset it.
                </p>
                <form onSubmit={submit} className="mt-12 space-y-8" data-testid="forgot-form">
                  <div>
                    <label htmlFor="forgot-email-input" className="font-mono text-[10px] tracking-[0.25em] text-white/40 block mb-3">EMAIL</label>
                    <input
                      id="forgot-email-input"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      data-testid="forgot-email"
                      className="w-full bg-transparent border-b border-white/20 focus:border-gold outline-none py-3 text-lg text-white transition-colors"
                      placeholder="you@dimension.com"
                    />
                  </div>
                  {error && <p className="text-red-500 text-sm font-mono" data-testid="forgot-error">{error}</p>}
                  <button
                    type="submit"
                    disabled={loading}
                    data-testid="forgot-submit"
                    className="w-full bg-gold text-black font-mono text-[11px] tracking-[0.25em] py-4 hover:bg-white transition-colors disabled:opacity-50"
                  >
                    {loading ? "SENDING..." : "SEND RESET LINK"}
                  </button>
                </form>
                <Link to="/login" data-testid="forgot-back-login" className="inline-block mt-10 font-mono text-[11px] tracking-[0.25em] text-white/50 hover:text-gold transition-colors">
                  ← BACK TO SIGN IN
                </Link>
              </>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
